import {callApi, uploadApi} from './Api';
import './Global';

/**
 *
 * @param{email, password)data
 */
export const createService = async(requestData={}) => {
    const functionUrl = "service";
    try {
        return await callApi(functionUrl, requestData )
            .then((response) => {
                return response;
            })
            // .catch((error) => {
            //     console.log("Error from API => ", error);
            // });
    } catch (error) {
        // console.log("Error from catch => ", error);
    }
};

/**
 *
 * @param{email, password)data
 */
export const serviceList = async( requestData = {} ) => {
    const functionUrl = "serviceList";

    try {
        return await callApi(functionUrl, requestData )
            .then((response) => {
                return response;
            })
            // .catch((error) => {
            //     console.log("Error from API => ", error);
            // });
    } catch (error) {
        // console.log("Error from catch => ", error);
    }
};

/**
 *
 * @param{get single service) by id
 */
export const updateService = async(requestData, id) => {
    const functionUrl = "service";
    try {
        return await callApi(functionUrl, requestData, 'PUT', id )
            .then((response) => {
                return response;
            })
            // .catch((error) => {
            //     console.log("Error from API => ", error);
            // });
    } catch (error) {
        // console.log("Error from catch => ", error);
    }
};


/**
 *
 * @param{delete service) by id
 */
export const deleteService = async(id) => {
    const functionUrl = "service";
    try {
        return await callApi(functionUrl, {}, 'DELETE', id )
            .then((response) => {
                return response;
            })
            // .catch((error) => {
            //     console.log("Error from API => ", error);
            // });
    } catch (error) {
        // console.log("Error from catch => ", error);
    }
};

/**
 *
 * @param{get single service) by id
 */
export const getService = async(id) => {
    const functionUrl = "service";
    try {
        return await callApi(functionUrl, {}, 'GET', id)
            .then((response) => {
                return response;
            })
            // .catch((error) => {
            //     console.log("Error from API => ", error);
            // });
    } catch (error) {
        // console.log("Error from catch => ", error);
    }
};

/**
 * Common Api for upload file or profile pic.
 * @param(file, callback) 
 * @return API response
*/
export const uploadFile = async (file, callBack, type) => {
	const functionUrl = 'uploadImage';
	try {
		const response = await uploadApi(functionUrl, file, callBack, type);
		if (response) {
			return callBack(response);
		}
	} catch (error) {
		// console.log('Error from catch => ', error);
	}
}

/**
 *
 * public api
 */
export const publicServiceList = async( categoryType ) => {
    const functionUrl = "getServiceslist";

    try {
        return await callApi(functionUrl, {}, "GET", categoryType )
            .then((response) => {
                return response;
            })
            // .catch((error) => {
            //     console.log("Error from API => ", error);
            // });
    } catch (error) {
        // console.log("Error from catch => ", error);
    }
};